<div class="cpjWrapper">
    <div class="cpj-header">
        <span class="cpj-title">{{ 'Home.cpj' | translate }}</span>
    </div>

    <div class="entries">
        <p class="featured-title">{{ 'Home.featuredarticle' | translate }}</p>

        <h3 class="entry-title">Hypertension Canada guideline for the diagnosis and treatment of hypertension in adults in primary care</h3>
        <p>
            Canada has historically been among the world leaders in hypertension care, but hypertension treatment and control 
            rates have regressed in recent years. This guideline is intended to provide pragmatic primary care-focused 
            recommendations to improve hypertension management in adults at the population level.
        </p>

        <p class="readmore"><a href="https://journals.sagepub.com/doi/full/10.1177/17151635251343907">{{ 'Home.readmore' | translate }}</a></p>
    </div>
</div>